/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Panel, Table } from 'react-bootstrap';
import RichLabel from 'loracoms/RichLabel';
import IntlMsg from 'lorautils/intl/IntlMsg';

const propTypes = {
  intl: intlShape.isRequired,
  status: PropTypes.string.isRequired,
  nodeStatus: PropTypes.object.isRequired,
};

class Channels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      status: props.status,
      nodeStatus: props.nodeStatus,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node.channel');
  }

  componentWillReceiveProps({ nodeStatus, status }) {
    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.setState({ nodeStatus });
    }
    if (status !== this.props.status) {
      this.setState({ status });
    }
  }

  render() {
    const {
      nodeStatus: { binds = [] } = {},
    } = this.state;
    return (
      <Panel
        bsStyle="aisz-white" header={this.intlMsg.msg('header')}
      >
        <Table className="aisz-table-light" striped>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('channel')}</th>
              <th>{this.intlMsg.msg('service')}</th>
              <th>{this.intlMsg.msg('frame')}</th>
              <th>{this.intlMsg.msg('offset')}</th>
            </tr>
          </thead>
          <tbody>
            {_.map(binds, (l, idx) => {
              let f = '';
              if (l.frame === 0) {
                f = 'FrameX';
              } else if (l.frame === 1) {
                f = 'FrameA';
              } else if (l.frame === 2) {
                f = 'FrameB';
              } else {
                f = l.frame;
              }
              return (
                <tr key={idx}>
                  <td><RichLabel content={String(l.channel)} /></td>
                  <td>{l.service}</td>
                  <td>{f}</td>
                  <td>{l.offset}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Panel>
    );
  }
}

Channels.propTypes = propTypes;

export default injectIntl(Channels);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/NodeStatus/Channels.jsx